import { isUndefined } from "@skylab-shared/utils";

export abstract class AvailabilityService<U> {
	private registered = false;

	public check(value: U | U[]): boolean {
		if (!this.registered) {
			throw new Error(`Availability service not registered`);
		}
		return this.onCheck(value);
	};
	protected abstract onCheck(value: U | U[]): boolean;

	public async registerAsync(...args: any[]): Promise<void> {
		if (this.registered) return;
		await this.onRegisterAsync(...args);
		this.registered = true;
	};
	protected abstract onRegisterAsync(...args: any[]): Promise<void>;
}

export class AvailabilityChecker<U> {
	public constructor(
		private availabilityService: AvailabilityService<U>
	) {}

    public create(value: U | U[]): boolean;
    public create<T>(value: U | U[], obj: T): T;
    public create<T>(value: U | U[], obj?: T): T | boolean {
		if (isUndefined(obj)) {
			return this.availabilityService.check(value);
		} else {
			if (this.availabilityService.check(value)) return obj;
			return null as T;
		}
	}
}

export const availabilityCheckerFactory = <U>(source: AvailabilityService<U>) => {
	const checker = new AvailabilityChecker(source);
	return checker.create.bind(checker);
};
